import http from './index.ts'

export const fetchUserInfoApi = () => {
    return http.get('/getInfo')
}
